import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { CarrouselDatas } from '../../Components/Public/Carrousel/CarrouselDatas.js';
import { CarrouselTotal } from '../../Components/Public/Carrousel/CarrouselTotal.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { Carrousel } from '../../Components/Public/Carrousel/Carrousel.js';
import { BlockLogoCharacters } from '../../Components/Public/Logos/BlockLogoCharacters.js';
import { InfosCharacter } from '../../Components/Public/Blocks/InfosCharacter.js';
import { BlockTitleDate1Link2 } from '../../Components/Public/Blocks/BlockTitleDate1Link2.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';
import { AnimCarrousel } from '../../Components/Public/Functions/AnimCarrousel.js';

export const RendezVousPersonnage = (props) => {
    const { navParks, id } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [character, setCharacter] = useState([]);
    useEffect(() => {
        const fetchtheData = async () => {
            const dataCharacter = await fetch(`${backend}/character?id=${id}`, GetHeaders(guest));
            const character = await dataCharacter.json();
            setCharacter(character);
        };
        fetchtheData();
        ScrollTop();
        AnimCarrousel();
    }, [backend, id, guest]);
    const carrouselDatas = CarrouselDatas('character', character);
    const carrouselTotal = CarrouselTotal('character', character);
    const items = GetDescription('rendez-vous-personnage', { character: character });
    return (
        <div className="character">
            <Navigation navParks={navParks} />
            <Header />
            <Carrousel label="character" datas={carrouselDatas} total={carrouselTotal} />
            <BreadCrumb label="rendez-vous-personnage" />
            <section className="infos">
                {character.map((item, i) => {
                    return (
                        <div className="bloc-infos" key={`i-${i}`}>
                            <BlockLogoCharacters label="rendez-vous-personnage" item={item} />
                            <InfosCharacter datas={character} />
                        </div>
                    )
                })}
                <div className="description">
                    <BlockTitleDate1Link2 label="rendez-vous-personnage" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}